export const COMMON_CERTIFICATIONS = [
  'bluesign® PRODUCT',
  'OEKO-TEX® STANDARD 100',
  'PFC-free / PFAS-free',
  'Fair Wear',
  'Fair Trade Certified™',
  'ClimatePartner / Carbon Neutral'
];

export const CERTIFICATIONS_BY_SCHEMA_KEY = {
  footwear: ['Vibram®', 'Leather Working Group (LWG)', 'GORE-TEX®', 'PFC-free / PFAS-free', 'Vegan Society Trademark'],
  hardshell_jacket: ['GORE-TEX®', 'ePE membrane', 'bluesign® APPROVED fabric', 'GRS recycled content'],
  hardshell_pants: ['GORE-TEX®', 'ePE membrane', 'bluesign® APPROVED fabric', 'GRS recycled content'],
  softshell_jacket: ['bluesign® PRODUCT', 'OEKO-TEX® STANDARD 100', 'PFC-free / PFAS-free', 'GRS recycled content'],
  softshell_pants: ['bluesign® PRODUCT', 'OEKO-TEX® STANDARD 100', 'PFC-free / PFAS-free', 'GRS recycled content'],
  fleece: ['Polartec®', 'Polartec® Power Grid™', 'GRS recycled polyester', 'bluesign® PRODUCT'],
  down_insulation: ['RDS (Responsible Down Standard)', 'Down Codex®', 'Nikwax Hydrophobic Down', 'bluesign® PRODUCT', 'PFC-free / PFAS-free'],
  synthetic_insulation: ['PrimaLoft®', 'PrimaLoft® Bio™', 'G-LOFT®', 'Thermore®', 'GRS recycled content', 'bluesign® PRODUCT'],
  baselayer_merino: ['OEKO-TEX® STANDARD 100', 'ZQ Merino', 'RWS (Responsible Wool Standard)', 'bluesign® PRODUCT'],
  baselayer_synthetic: ['OEKO-TEX® STANDARD 100', 'bluesign® PRODUCT', 'GRS recycled content'],
  crampons: ['CE', 'EN 893', 'UIAA 153'],
  ice_axes: ['CE', 'EN 13089', 'UIAA 152'],
  ropes: ['CE', 'EN 892', 'UIAA Safety Label', 'bluesign®'],
  carabiners: ['CE', 'EN 12275', 'UIAA 121'],
  backpacks: ['bluesign® PRODUCT', 'GRS recycled content', 'PFC-free DWR', 'Fair Wear'],
  accessories: ['bluesign® PRODUCT', 'OEKO-TEX® STANDARD 100', 'RWS (Responsible Wool Standard)', 'Leather Working Group (LWG)', 'PFC-free / PFAS-free'],
  helmets: ['CE', 'EN 12492', 'UIAA 106'],
  harnesses: ['CE', 'EN 12277', 'UIAA 105'],
  hardware: ['CE', 'UIAA Safety Label', 'EN 12275 / EN 566 / EN 354'],
  trekking_poles: ['TÜV tested', 'Carbon Trust', 'GRS recycled content'],
  eyewear: ['CE', 'EN ISO 12312-1', 'UV400'],
  electronics: ['CE', 'RoHS', 'WEEE', 'IPX4/IPX7']
};

export const getAllCertificationTags = () => {
  const all = [...COMMON_CERTIFICATIONS, ...Object.values(CERTIFICATIONS_BY_SCHEMA_KEY).flat()];
  const unique = new Set();
  const output = [];

  all.forEach((item) => {
    const value = String(item || '').trim();
    if (!value) return;
    const key = value.toLowerCase();
    if (unique.has(key)) return;
    unique.add(key);
    output.push(value);
  });

  return output;
};

export const getCertificationAnchorId = (value) => {
  const normalized = String(value || '').toLowerCase().trim();
  if (!normalized) return 'certification';

  const base = normalized
    .replace(/®|™/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return `cert-${base || 'item'}`;
};
